import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';

import {HomeComponent} from './home/home.component';
import {SignInComponent} from './auth/sign-in/sign-in.component';
import {ForgotPasswordComponent} from './auth/forgot-password/forgot-password.component';
import {DashboardComponent} from './dashboard/dashboard.component';
import {AccountComponent} from './account/account.component';
import {MemberComponent} from './member/member.component'
import {RegionalComponent} from './regional/regional.component';
import {PageNotFoundComponent} from './shared/pages/page-not-found/page-not-found.component';
import {EventComponent} from './event/event.component';
import {RoomComponent} from './room/room.component';
import {TeamRoleComponent} from './team-role/team-role.component';
import {ProductComponent} from './product/product.component';
// import {PrivateStoreComponent} from './private-store/private-store.component';
import {OrderedComponent} from './ordered/ordered.component';
import {WaitingListComponent} from './waiting-list/waiting-list.component';
import {SecureInnerPagesGuard} from './shared/guard/secure-inner-pages.guard';
import {AuthGuard} from "./shared/guard/auth.guard";
import {StaffComponent} from './staff/staff.component';
//import {InviteMailBackComponent} from './invite-mail-back/invite-mail-back.component';
import {TaxComponent} from './tax/tax.component';
import {PushComponent} from './push/push.component';
import {SubcategoryComponent} from './subcategory/subcategory.component';
import {NewsComponent} from './news/news.component';
import {SponsorComponent} from './sponsor/sponsor.component';
import {SponsorCongressComponent} from './sponsor-congress/sponsor-congress.component';
import {PushSponsorComponent} from './push-sponsor/push-sponsor.component';
import {BannerSponsorComponent} from './banner-sponsor/banner-sponsor.component';
import {QueryComponent} from './query/query.component';
import {WebnarComponent} from './webnar/webnar.component';
//import {CertificateComponent} from './certificate/certificate.component';
import {RefundComponent} from './refund/refund.component';
//import {_AnnuityComponent} from './annuity/_annuity.component';
import {AnnuityComponent} from './annuity/annuity.component';
import {AnnuityReportComponent} from './annuity/pages/annuity-report.component';
import {DocumentComponent} from './document/document.component';

// import {LetterComponent} from './letter/letter.component';
// import {LetterShippingComponent} from './letter-shipping/letter-shipping.component';
//import {QuizComponent} from './quiz/quiz.component';
//import {QuizInviteComponent} from './quiz-invite/quiz-invite.component';
//import {QuizBackComponent} from './quiz-back/quiz-back.component';
//import {QuizThanksComponent} from './quiz-back/page/quiz-thanks/quiz-thanks.component';
//import {QuizResponseComponent} from './quiz-response/quiz-response.component';
import {VoucherComponent} from './voucher/voucher.component';
//import {QuizViewerComponent} from './quiz-viewer/quiz-viewer.component';

import {KnowledgeComponent} from './knowledge/knowledge.component';
import {KnowledgeViewerComponent} from './knowledge/pages/knowledge-viewer/knowledge-viewer.component';

import {CompanionComponent} from './companion/companion.component';

import {TransferComponent} from './transfer/transfer.component';

import {ConfigComponent} from './config/config.component';



// import {BalconyComponent} from './balcony/balcony.component';
// import {BalconyOneComponent} from './balcony/pages/balcony-one/balcony-one.component';
import {HelperComponent} from './helper/helper.component';
//import {RecordSlotsComponent} from './record-slots/record-slots.component';
import {CongressesComponent} from './congresses/congresses.component';
//import {InviteAgendaBackComponent} from './invite-agenda-back/invite-agenda-back.component';
//import {InviteAgendaDatesComponent} from './invite-agenda-back/pages/invite-agenda-dates/invite-agenda-dates.component';
//import {InviteAgendaConfirmComponent} from './invite-agenda-back/pages/invite-agenda-confirm/invite-agenda-confirm.component';
//import {InviteAgendaItensComponent} from './invite-agenda-back/pages/invite-agenda-itens/invite-agenda-itens.component';
//import {InviteAgendaEndComponent} from './invite-agenda-back/pages/invite-agenda-end/invite-agenda-end.component';
//import {InviteAgendaErrorComponent} from './invite-agenda-back/pages/invite-agenda-error/invite-agenda-error.component';


//import {InviteUpdateBackComponent} from './invite-update-back/invite-update-back.component';

//import {InviteConfirmDatesComponent} from './invite-confirm-back/pages/invite-confirm-dates/invite-confirm-dates.component';
//import {InviteConfirmConfirmComponent} from './invite-confirm-back/pages/invite-confirm-confirm/invite-confirm-confirm.component';
//import {InviteConfirmItensComponent} from './invite-confirm-back/pages/invite-confirm-itens/invite-confirm-itens.component';
//import {InviteConfirmEndComponent} from './invite-confirm-back/pages/invite-confirm-end/invite-confirm-end.component';
//import {InviteConfirmErrorComponent} from './invite-confirm-back/pages/invite-confirm-error/invite-confirm-error.component';
//import {InviteConfirmDecideComponent} from './invite-confirm-back/pages/invite-confirm-decide/invite-confirm-decide.component';

//import {InviteConfirmBackComponent} from './invite-confirm-back/invite-confirm-back.component';

import {AgendaMemberComponent} from './agenda-member/agenda-member.component';
// import {CongressLettersComponent} from './congresses/pages/congress-letters/congress-letters.component';
// import {CongressInvitesComponent} from './congresses/pages/congress-invites/congress-invites.component';
// import {CongressResponsesComponent} from './congresses/pages/congress-responses/congress-responses.component';
//import {InviteConfirmScheduleComponent} from './invite-confirm-back/pages/invite-confirm-schedule/invite-confirm-schedule.component';

import {SubscriptionsComponent} from './subscriptions/subscriptions.component';
import {ReportsComponent} from './reports/reports.component';
import {HistoricComponent} from './historic/historic.component';
import {CongressHistoricComponent} from './congress-historic/congress-historic.component';
import {ReportsSubscriptionsComponent} from './reports-subscriptions/reports-subscriptions.component';
//import {LettersV2Component} from './letters-v2/letters-v2.component';
// import { InviteConfirmComponent } from './lettersBack/invite-confirm.component';
// import { InviteEndComponent } from './lettersBack/invite-end.component';
// import { InviteUpdateComponent } from './lettersBack/invite-update.component';
// import { InviteUpdateDataComponent } from './lettersBack/invite-update-data.component';
//import {ResponsesV2Component} from './letters-v2/pages/responses-v2/responses-v2.component';
//import {CongressResponsesV2Component} from './congresses/pages/congress-responses-v2/congress-responses-v2.component';
import {FrontDeskComponent} from './balcony/pages/front-desk/front-desk.component';
import {FrontDeskProductsComponent} from './balcony/pages/front-desk-products/front-desk-products.component';
import {FrontDeskRegisterComponent} from './balcony/pages/front-desk-register/front-desk-register.component';
import {FrontDeskMemberComponent} from './balcony/pages/front-desk-member/front-desk-member.component';
import {FrontDeskOrdersComponent} from './balcony/pages/front-desk-orders/front-desk-orders.component';
import {FrontDeskConfirmationComponent} from './balcony/pages/front-desk-confirmation/front-desk-confirmation.component';
import {CaexComponent} from './caex/caex/caex.component';
import {CaexMemberComponent} from './caex/caex-member/caex-member.component';
import {CaexOrderComponent} from './caex/caex-order/caex-order.component';
import {CaexProductComponent} from './caex/caex-product/caex-product.component';
import {CaexConfirmationComponent} from './caex/caex-confirmation/caex-confirmation.component';
import {CaexPaymentComponent} from './caex/caex-payment/caex-payment.component';
import {CaexNewMemberComponent} from './caex/caex-new-member/caex-new-member.component';
import {CaexTotenComponent} from './caex/caex-toten/caex-toten.component';
import {TotenComponent} from './toten/toten.component';
import {TotenReportComponent} from './toten-report/toten-report.component';
//import {InvitesV2Component} from './letters-v2/pages/invites-v2/invites-v2.component';
import {WellcomeComponent} from './wellcome/wellcome.component';
//import {ConfirmBackComponent} from './invite-back-v2/confirm-back/confirm-back.component';
//import {UpdateDataComponent} from './invite-back-v2/update-data/update-data.component';
//import {EndBackComponent} from './invite-back-v2/end-back/end-back.component';
import {PreviewComponent} from './congresses/preview/preview.component';

import {Gn1Component} from './gn1/gn1.component';
import {AnnuityGn1Component} from './annuity-gn1/annuity-gn1.component';

import {DepartmentComponent} from './department/department.component';
import {ConventionCenterComponent} from './convention-center/convention-center.component';

//import {ScheduleCongressComponent} from './schedule-congress/schedule-congress.component';
import {CieloLabComponent} from './cielo-lab/cielo-lab.component';

import {Archive49Component} from './congresses/archives/archive49/archive49.component';
import {Archive50Component} from './congresses/archives/archive50/archive50.component';

import {MemberCollectBackComponent} from './member/pages/member-collect-back/member-collect-back.component';

import {ReportsCollectComponent} from './reports-collect/reports-collect.component';

import {MemberGN1Component} from './member-gn1/member-gn1.component';
import {MemberGN1WorkComponent} from './member-gn1-work/member-gn1-work.component';
import {EventPublishComponent} from './event-publish/event-publish.component';
import {EventScheduleComponent} from './event-schedule/event-schedule.component';

import {LabPageComponent} from './lab-page/lab-page.component';

import {TutorComponent} from './tutor/tutor.component';

import {LabLojaPageComponent} from './lab-loja-page/lab-loja-page.component';
import {LabLoja2PageComponent} from './lab-loja-page/pages/lab-loja2-page.component';

import {LettersSubscriptionsComponent} from './letters-subscriptions/letters-subscriptions/letters-subscriptions.component';
import {LettersSubscribersBackComponent} from './letters-subscriptions/back/letters-subscribers-back/letters-subscribers-back.component';
import {LettersSpeakersComponent} from './letters-speakers/letters-speakers/letters-speakers.component';
import {SpeakerConfirmBackComponent} from './letters-speakers/back/speaker-confirm-back/speaker-confirm-back.component';
import {SpeakerUpdateDataComponent} from './letters-speakers/back/speaker-update-data/speaker-update-data.component';
import {SpeakerEndBackComponent} from './letters-speakers/back/speaker-end-back/speaker-end-back.component';
import {CongressEventsComponent} from './congresses/pages/congress-events/congress-events.component';

import {CertificatesSpeakersComponent} from './certificates-speakers/certificates-speakers.component';
import {CertificatesSpeakers_v2Component} from './certificates-speakers_v2/certificates-speakers_v2.component';

import {CertificatesSubscriptionsComponent} from './certificates-subscriptions/certificates-subscriptions.component';
import {CertificatesArchivesComponent} from './certificates-archives/certificates-archives.component';


import {StoreComponent} from './store/store.component';
import {StoreItensComponent} from './store/pages/store-itens/store-itens.component';
import {StoreItemComponent} from './store/pages/store-item/store-item.component';

import {ReportsCategoryComponent} from './reports-category/reports-category.component';

import {AnnuityLetterComponent} from './annuity-letter/annuity-letter.component';
import {AnnuityBackComponent} from './annuity-letter/pages/annuity-back/annuity-back.component';
import {AnnuityPaymentComponent} from './annuity-letter/pages/annuity-payment/annuity-payment.component';

import {PagesComponent} from './site-pub/pages/pages/pages.component';

import {DirectorsComponent} from './site-pub/pages/directors/directors.component';
import {LinksComponent} from './site-pub/pages/links/links.component';

import {StatuteComponent} from './site-pub/pages/statute/statute.component';
import {HistoryComponent} from './site-pub/pages/history/history.component';
import {ConductComponent} from './site-pub/pages/conduct/conduct.component';


import {DeptosComponent} from './site-pub/pages/deptos/deptos.component';
import {ExamsComponent} from './site-pub/pages/exams/exams.component';

import {RegionalsComponent} from './site-pub/pages/regionals/regionals.component';
import {CarouselComponent} from './site-pub/pages/carousel/carousel.component';
import {SiteNewsComponent} from './site-pub/pages/site-news/site-news.component';
import {YoutubeComponent} from './site-pub/pages/youtube/youtube.component';
import {GalleryComponent} from './site-pub/pages/gallery/gallery.component';
import {SiteEventsComponent} from './site-pub/pages/site-events/site-events.component';
import {BulletinComponent} from './site-pub/pages/bulletin/bulletin.component';
import {MagazinesComponent} from './site-pub/pages/magazines/magazines.component';
import {TaviDocsComponent} from './site-pub/pages/tavi-docs/tavi-docs.component';
import {TaviProfsComponent} from './site-pub/pages/tavi-profs/tavi-profs.component';
import {TaviCentersComponent} from './site-pub/pages/tavi-centers/tavi-centers.component';
import {ResidentsComponent} from './site-pub/pages/residents/residents.component';
import {RegulationsComponent} from './site-pub/pages/regulations/regulations.component';
import {GuidelinesComponent} from './site-pub/pages/guidelines/guidelines.component';
import {CongressesBeforeComponent} from './site-pub/pages/congresses-before/congresses-before.component';
import {SiteEventsFormComponent} from './site-pub/pages/site-events-form/site-events-form.component';
import {BecomeMemberComponent} from './site-pub/pages/become-member/become-member.component';
import {CongressCurrentComponent} from './site-pub/pages/congress-current/congress-current.component';
import {VimeoComponent} from './site-pub/pages/vimeo/vimeo.component';
import {ArtigosCientificosComponent} from './site-pub/pages/artigos-cientificos/artigos-cientificos.component';
import {PdfsComponent} from './site-pub/pages/pdfs/pdfs.component';
import {SiteLogsComponent} from './site-logs/site-logs.component';
import {ExhibitorsComponent} from './site-pub/pages/exhibitors/exhibitors.component';
import {CountriesComponent} from './countries/countries.component';

const routes: Routes = [

  {path: '', redirectTo: 'home', pathMatch: 'full'},

  {path: 'home', component: HomeComponent},

  {path: 'lab', component: LabPageComponent, canActivate: [ AuthGuard ]},
  {path: 'loja', component: LabLojaPageComponent, canActivate: [ AuthGuard ]},
  {path: 'loja2', component: LabLoja2PageComponent, canActivate: [ AuthGuard ]},

  {path: 'store', component: StoreComponent, canActivate: [ AuthGuard ]},
  {path: 'store-itens/:param', component: StoreItensComponent, canActivate: [ AuthGuard ]},
  {path: 'store-item/:param', component: StoreItemComponent, canActivate: [ AuthGuard ]},

  //{path: 'schedule-congress', component: ScheduleCongressComponent, canActivate: [ AuthGuard ]},


  {path: 'event-publish/:key', component: EventPublishComponent, canActivate: [ AuthGuard ]},
  {path: 'programa/:key', component: EventScheduleComponent},

  {path: 'agenda-member', component: AgendaMemberComponent, canActivate: [ AuthGuard ]},

  {path: 'wellcome', component: WellcomeComponent, canActivate: [ AuthGuard ]},
  {path: 'dashboard', component: DashboardComponent, canActivate: [ AuthGuard ]},
  {path: 'account', component: AccountComponent, canActivate: [ AuthGuard ]},
  {path: 'member', component: MemberComponent, canActivate: [ AuthGuard ]},

  {path: 'member-collect/:collect_id', component: MemberCollectBackComponent},

  {path: 'member-gn1', component: MemberGN1Component, canActivate: [ AuthGuard ]},
  {path: 'member-gn1-work', component: MemberGN1WorkComponent, canActivate: [ AuthGuard ]},

  {path: 'gn1', component: Gn1Component, canActivate: [ AuthGuard ]},
  {path: 'cielo-lab', component: CieloLabComponent, canActivate: [ AuthGuard ]},

  //{path: 'category', component: CategoryComponent, canActivate: [AuthGuard]},
  {path: 'subcategory', component: SubcategoryComponent, canActivate: [ AuthGuard ]},
  {path: 'regional', component: RegionalComponent, canActivate: [ AuthGuard ]},

  {path: 'department', component: DepartmentComponent, canActivate: [ AuthGuard ]},
  {path: 'convention-center', component: ConventionCenterComponent, canActivate: [ AuthGuard ]},


  {path: 'reports', component: ReportsComponent, canActivate: [ AuthGuard ]},
  {path: 'reports-subscriptions', component: ReportsSubscriptionsComponent, canActivate: [ AuthGuard ]},
  {path: 'reports-collect', component: ReportsCollectComponent, canActivate: [ AuthGuard ]},

  {path: 'reports-category', component: ReportsCategoryComponent, canActivate: [ AuthGuard ]},

  {path: 'site-logs', component: SiteLogsComponent, canActivate: [ AuthGuard ]},

  {path: 'event', component: EventComponent, canActivate: [ AuthGuard ]},

  //letter-v2
  // {path: 'letters-v2/:event_id/:event_name/:isCongress', component: LettersV2Component, canActivate: [ AuthGuard ]},
  // {path: 'invites-v2/:event_id/:event_name/:isCongress', component: InvitesV2Component, canActivate: [ AuthGuard ]},
  // {path: 'responses-v2/:event_id/:event_name/:isCongress', component: ResponsesV2Component, canActivate: [ AuthGuard ]},

  //letterBack
  /*
  {path: 'invite_confirm/:uid', component: InviteConfirmComponent},
  {path: 'invite_update/:uid', component: InviteUpdateComponent},
  {path: 'invite_update_data/:uid', component: InviteUpdateDataComponent},
  {path: 'invite_end', component: InviteEndComponent },
  */

  {path: 'historic', component: HistoricComponent, canActivate: [ AuthGuard ]},
  {path: 'congress-historic', component: CongressHistoricComponent, canActivate: [ AuthGuard ]},

  {path: 'congress', component: CongressesComponent, canActivate: [ AuthGuard ]},
  {path: 'congress-events/:uid', component: CongressEventsComponent, canActivate: [ AuthGuard ]},

  {path: '49', component: Archive49Component},
  {path: '50', component: Archive50Component},

  {path: 'certificates-speakers/:isCongress/:uid', component: CertificatesSpeakersComponent, canActivate: [ AuthGuard ]},
  {path: 'certificates-speakers_v2/:isCongress/:uid', component: CertificatesSpeakers_v2Component, canActivate: [ AuthGuard ]},
  
  {path: 'certificates-subscriptions/:isCongress/:uid', component: CertificatesSubscriptionsComponent, canActivate: [ AuthGuard ]},
  {path: 'certificates-archives/:isCongress', component: CertificatesArchivesComponent, canActivate: [ AuthGuard ]},

  {path: 'letters-subscriptions/:isCongress/:uid', component: LettersSubscriptionsComponent, canActivate: [ AuthGuard ]},
  {path: 'subscribers/:token', component: LettersSubscribersBackComponent},

  {path: 'letters-speakers/:isCongress/:uid', component: LettersSpeakersComponent, canActivate: [ AuthGuard ]},
  {path: 'speaker-confirm-back/:uid', component: SpeakerConfirmBackComponent},
  {path: 'speaker-update-back/:uid', component: SpeakerUpdateDataComponent},
  {path: 'speaker-end-back', component: SpeakerEndBackComponent},

  /*
  {path: 'congress-letters/:event_id/:event_name', component: CongressLettersComponent, canActivate: [ AuthGuard ]},
  {path: 'congress-invites/:event_id/:event_name', component: CongressInvitesComponent, canActivate: [ AuthGuard ]},
  {path: 'congress-responses/:event_id/:event_name', component: CongressResponsesComponent, canActivate: [ AuthGuard ]},
  {path: 'congress-responses-v2', component: CongressResponsesV2Component, canActivate: [ AuthGuard ]},
  */

  {path: 'room', component: RoomComponent, canActivate: [ AuthGuard ]},
  {path: 'role', component: TeamRoleComponent, canActivate: [ AuthGuard ]},
  {path: 'product', component: ProductComponent, canActivate: [ AuthGuard ]},

  {path: 'annuity', component: AnnuityComponent, canActivate: [ AuthGuard ]},
  {path: 'annuity-report/:id', component: AnnuityReportComponent, canActivate: [ AuthGuard ]},
  {path: 'annuity-gn1', component: AnnuityGn1Component, canActivate: [ AuthGuard ]},

  {path: 'annuity-letter', component: AnnuityLetterComponent, canActivate: [ AuthGuard ]},
  {path: 'annuity-back/:uid', component: AnnuityBackComponent},
  {path: 'annuity-pay', component: AnnuityPaymentComponent},

  // {path: 'store', component: PrivateStoreComponent, canActivate: [AuthGuard]},
  {path: 'ordered', component: OrderedComponent, canActivate: [ AuthGuard ]},

  {path: 'waiting', component: WaitingListComponent, canActivate: [ AuthGuard ]},
  {path: 'refund', component: RefundComponent, canActivate: [ AuthGuard ]},
  //{path: 'annuities', component: _AnnuityComponent, canActivate: [AuthGuard]},
  {path: 'config', component: ConfigComponent, canActivate: [ AuthGuard ]},
  {path: 'document', component: DocumentComponent, canActivate: [ AuthGuard ]},

  {path: 'staff', component: StaffComponent, canActivate: [ AuthGuard ]},
  {path: 'tax', component: TaxComponent, canActivate: [ AuthGuard ]},
  {path: 'push', component: PushComponent, canActivate: [ AuthGuard ]},
  {path: 'news', component: NewsComponent, canActivate: [ AuthGuard ]},
  {path: 'sponsor', component: SponsorComponent, canActivate: [ AuthGuard ]},

  {path: 'transfer', component: TransferComponent, canActivate: [ AuthGuard ]},

  {path: 'voucher', component: VoucherComponent, canActivate: [ AuthGuard ]},
  {path: 'manuals', component: KnowledgeComponent, canActivate: [ AuthGuard ]},
  {path: 'knowledge_viewer/:uid', component: KnowledgeViewerComponent},

  {path: 'push_sponsor', component: PushSponsorComponent, canActivate: [ AuthGuard ]},
  {path: 'banner_sponsor', component: BannerSponsorComponent, canActivate: [ AuthGuard ]},
  {path: 'webnar', component: WebnarComponent, canActivate: [ AuthGuard ]},

  //{path: 'quiz', component: QuizComponent, canActivate: [ AuthGuard ]},
  //{path: 'quiz_invite', component: QuizInviteComponent, canActivate: [ AuthGuard ]},
  //{path: 'quiz_back/:uid', component: QuizBackComponent},
  //{path: 'quiz_thanks', component: QuizThanksComponent},
  //{path: 'quiz_response', component: QuizResponseComponent, canActivate: [ AuthGuard ]},
  //{path: 'quiz_viewer/:uid', component: QuizViewerComponent},

  // {path: 'invite_mail_back/:uid', component: InviteMailBackComponent},
  //{path: 'invite_update_back/:uid', component: InviteUpdateBackComponent},

  //////////////////////////////////////////////////////
  //{path: 'invite_agenda_back/:uid', component: InviteAgendaBackComponent},
  //{path: 'invite-agenda-dates', component: InviteAgendaDatesComponent},
  //{path: 'invite-agenda-confirm', component: InviteAgendaConfirmComponent},
  //{path: 'invite-agenda-itens', component: InviteAgendaItensComponent},
  //{path: 'invite-agenda-end', component: InviteAgendaEndComponent},
  // {path: 'invite-agenda-error', component: InviteAgendaErrorComponent},

  //////////////////////////////////////////////////////////////////
  // {path: 'invite_confirm_back/:uid', component: InviteConfirmBackComponent},
  //{path: 'invite-confirm-decide', component: InviteConfirmDecideComponent},
  //{path: 'invite-confirm-dates', component: InviteConfirmDatesComponent},
  //{path: 'invite-confirm-confirm', component: InviteConfirmConfirmComponent},
  //{path: 'invite-confirm-itens', component: InviteConfirmItensComponent},
  //{path: 'invite-confirm-end', component: InviteConfirmEndComponent},
  //{path: 'invite-confirm-error', component: InviteConfirmErrorComponent},
  //{path: 'invite-confirm-schedule', component: InviteConfirmScheduleComponent},


  //////////////////////////////////////////////////////////////////
  // confirm-back-v2
  //{path: 'confirm_back_v2/:uid', component: ConfirmBackComponent},
  //{path: 'update_back_v2/:uid', component: UpdateDataComponent},
  //{path: 'end-back', component: EndBackComponent},
  //////////////////////////////////////////////////////////////////

  {path: 'sign-in', component: SignInComponent, canActivate: [ SecureInnerPagesGuard ]},
  {path: 'forgot-password', component: ForgotPasswordComponent, canActivate: [ SecureInnerPagesGuard ]},

  {path: 'companion', component: CompanionComponent, canActivate: [ AuthGuard ]},

  {path: 'front-desk', component: FrontDeskComponent, canActivate: [ AuthGuard ]},
  {path: 'front-desk-products', component: FrontDeskProductsComponent, canActivate: [ AuthGuard ]},
  {path: 'front-desk-register', component: FrontDeskRegisterComponent, canActivate: [ AuthGuard ]},
  {path: 'front-desk-member', component: FrontDeskMemberComponent, canActivate: [ AuthGuard ]},
  {path: 'front-desk-orders', component: FrontDeskOrdersComponent, canActivate: [ AuthGuard ]},
  {path: 'front-desk-confirmation', component: FrontDeskConfirmationComponent, canActivate: [ AuthGuard ]},

  {path: 'caex', component: CaexComponent, canActivate: [ AuthGuard ]},
  {path: 'caex-products', component: CaexProductComponent, canActivate: [ AuthGuard ]},
  {path: 'caex-new-member', component: CaexNewMemberComponent, canActivate: [ AuthGuard ]},
  {path: 'caex-member', component: CaexMemberComponent, canActivate: [ AuthGuard ]},
  {path: 'caex-orders', component: CaexOrderComponent, canActivate: [ AuthGuard ]},
  {path: 'caex-payment', component: CaexPaymentComponent, canActivate: [ AuthGuard ]},
  {path: 'caex-confirmation', component: CaexConfirmationComponent, canActivate: [ AuthGuard ]},
  {path: 'caex-toten', component: CaexTotenComponent, canActivate: [ AuthGuard ]},

  // {path: 'balcony', component: BalconyComponent, canActivate: [ AuthGuard ]},
  // {path: 'balcony-one', component: BalconyOneComponent, canActivate: [ AuthGuard ]},

  {path: 'toten/:doc', component: TotenComponent, canActivate: [ AuthGuard ]},
  {path: 'toten-report', component: TotenReportComponent, canActivate: [ AuthGuard ]},

  {path: 'query', component: QueryComponent},

  {path: 'helper', component: HelperComponent, canActivate: [ AuthGuard ]},

  //{path: 'record-slots', component: RecordSlotsComponent, canActivate: [ AuthGuard ]},
  {path: 'subscriptions', component: SubscriptionsComponent, canActivate: [ AuthGuard ]},

  {path: 'tutor', component: TutorComponent},

  {path: 'pages/:depto/:page', component: PagesComponent},
  {path: 'directors', component: DirectorsComponent, canActivate: [ AuthGuard ]},
  {path: 'links', component: LinksComponent, canActivate: [ AuthGuard ]},
  {path: 'statute', component: StatuteComponent, canActivate: [ AuthGuard ]},
  {path: 'history', component: HistoryComponent, canActivate: [ AuthGuard ]},
  {path: 'conduct', component: ConductComponent, canActivate: [ AuthGuard ]},
  {path: 'deptos', component: DeptosComponent, canActivate: [ AuthGuard ]},
  {path: 'exams', component: ExamsComponent, canActivate: [ AuthGuard ]},
  {path: 'regionals', component: RegionalsComponent, canActivate: [ AuthGuard ]},
  {path: 'carousel', component: CarouselComponent, canActivate: [ AuthGuard ]},
  {path: 'site-news', component: SiteNewsComponent, canActivate: [ AuthGuard ]},
  {path: 'youtube', component: YoutubeComponent, canActivate: [ AuthGuard ]},
  {path: 'vimeo', component: VimeoComponent, canActivate: [ AuthGuard ]},
  {path: 'gallery', component: GalleryComponent, canActivate: [ AuthGuard ]},
  {path: 'site-events-form', component: SiteEventsFormComponent, canActivate: [ AuthGuard ]},
  {path: 'site-events', component: SiteEventsComponent, canActivate: [ AuthGuard ]},
  {path: 'bulletin', component: BulletinComponent, canActivate: [ AuthGuard ]},
  {path: 'magazines', component: MagazinesComponent, canActivate: [ AuthGuard ]},
  {path: 'tavi-docs', component: TaviDocsComponent, canActivate: [ AuthGuard ]},
  {path: 'tavi-profs', component: TaviProfsComponent, canActivate: [ AuthGuard ]},
  {path: 'tavi-centers', component: TaviCentersComponent, canActivate: [ AuthGuard ]},
  {path: 'residents', component: ResidentsComponent, canActivate: [ AuthGuard ]},
  {path: 'regulations', component: RegulationsComponent, canActivate: [ AuthGuard ]},
  {path: 'guidelines', component: GuidelinesComponent, canActivate: [ AuthGuard ]},
  {path: 'congressos', component: CongressesBeforeComponent, canActivate: [ AuthGuard ]},
  {path: 'congresso-atual', component: CongressCurrentComponent, canActivate: [ AuthGuard ]},
  {path: 'become-member', component: BecomeMemberComponent, canActivate: [ AuthGuard ]},
  {path: 'artigos-cientificos', component: ArtigosCientificosComponent, canActivate: [ AuthGuard ]},
  {path: 'pdfs', component: PdfsComponent, canActivate: [ AuthGuard ]},
  {path: 'expositores', component: ExhibitorsComponent, canActivate: [ AuthGuard ]},

  {path: 'country', component: CountriesComponent, canActivate: [ AuthGuard ]},

  {path: '**', component: PageNotFoundComponent} ]


@NgModule({
  imports: [ RouterModule.forRoot(routes) ],
  exports: [ RouterModule ]
})

export class AppRoutingModule { }
export const routingComponents = [
  PageNotFoundComponent,
  HomeComponent,
  DashboardComponent,
  SignInComponent,
  ForgotPasswordComponent,
  AccountComponent,
  MemberComponent,
  RegionalComponent,
  EventComponent,
  RoomComponent,
  TeamRoleComponent,
  ProductComponent,
  OrderedComponent,
  StaffComponent,
  //InviteMailBackComponent,
  TaxComponent,
  PushComponent,
  SubcategoryComponent,
  NewsComponent,
  SponsorComponent,
  SponsorCongressComponent,
  BannerSponsorComponent,
  PushSponsorComponent,
  QueryComponent,
  WebnarComponent,
  RefundComponent,
  AnnuityComponent,
  AnnuityReportComponent,
  DocumentComponent,
  //QuizComponent,
  //QuizBackComponent,
  //QuizThanksComponent,
  //QuizResponseComponent,
  //QuizInviteComponent,
  VoucherComponent,
  //QuizViewerComponent,
  WaitingListComponent,
  KnowledgeComponent,
  KnowledgeViewerComponent,
  CompanionComponent,
  TransferComponent,
  ConfigComponent,
  // BalconyComponent,
  // BalconyOneComponent,
  HelperComponent,
  //RecordSlotsComponent,
  CongressesComponent,
  //InviteAgendaBackComponent,
  //InviteAgendaDatesComponent,
  //InviteAgendaConfirmComponent,
  //  InviteAgendaItensComponent,
  //InviteAgendaEndComponent,
  //InviteAgendaErrorComponent,
  //InviteUpdateBackComponent,
  AgendaMemberComponent,
  //InviteConfirmBackComponent,

  //InviteConfirmBackComponent,
  //InviteConfirmDatesComponent,
  //InviteConfirmConfirmComponent,
  //InviteConfirmItensComponent,
  //InviteConfirmEndComponent,
  //InviteConfirmErrorComponent,
  //  InviteConfirmDecideComponent,

  // CongressLettersComponent,
  // CongressInvitesComponent,
  // CongressResponsesComponent,

  //InviteConfirmScheduleComponent,
  SubscriptionsComponent,
  ReportsComponent,
  HistoricComponent,
  CongressHistoricComponent,
  ReportsSubscriptionsComponent,

  // LettersV2Component,
  // InvitesV2Component,
  // ResponsesV2Component,

  // CongressResponsesV2Component,
  FrontDeskComponent,
  FrontDeskProductsComponent,
  FrontDeskRegisterComponent,
  FrontDeskMemberComponent,
  FrontDeskOrdersComponent,
  FrontDeskConfirmationComponent,

  CaexComponent,
  CaexMemberComponent,
  CaexOrderComponent,
  CaexProductComponent,
  CaexPaymentComponent,
  CaexConfirmationComponent,
  CaexNewMemberComponent,
  CaexTotenComponent,
  TotenComponent,
  TotenReportComponent,
  WellcomeComponent,
  //ConfirmBackComponent,
  //UpdateDataComponent,
  //EndBackComponent,
  PreviewComponent,
  Gn1Component,
  AnnuityGn1Component,
  DepartmentComponent,
  ConventionCenterComponent,
  //ScheduleCongressComponent,
  EventScheduleComponent,
  EventPublishComponent,
  CieloLabComponent,

  Archive49Component,
  Archive50Component,

  MemberCollectBackComponent,
  ReportsCollectComponent,

  ReportsCategoryComponent,

  MemberGN1Component,
  MemberGN1WorkComponent,

  LabPageComponent,
  TutorComponent,
  LabLojaPageComponent,
  LabLoja2PageComponent,
  LettersSubscribersBackComponent,
  LettersSubscriptionsComponent,
  LettersSpeakersComponent,
  SpeakerConfirmBackComponent,
  SpeakerUpdateDataComponent,
  SpeakerEndBackComponent,
  CongressEventsComponent,
  CertificatesSpeakersComponent,
  CertificatesSpeakers_v2Component,
  CertificatesSubscriptionsComponent,
  CertificatesArchivesComponent,
  AnnuityLetterComponent,
  AnnuityBackComponent,
  AnnuityPaymentComponent,
  SiteLogsComponent,
  
  StoreComponent,
  StoreItensComponent,
  StoreItemComponent,

  PagesComponent,
  DirectorsComponent,
  LinksComponent,
  StatuteComponent,
  HistoryComponent,
  ConductComponent,
  DeptosComponent,
  ExamsComponent,
  RegionalsComponent,
  CarouselComponent,
  SiteNewsComponent,
  YoutubeComponent,
  GalleryComponent,
  SiteEventsComponent,
  BulletinComponent,
  MagazinesComponent,
  TaviDocsComponent,
  TaviProfsComponent,
  TaviCentersComponent,
  ResidentsComponent,
  RegulationsComponent,
  GuidelinesComponent,
  CongressesBeforeComponent,
  SiteEventsFormComponent,
  BecomeMemberComponent,
  CongressCurrentComponent,
  VimeoComponent,
  ArtigosCientificosComponent,
  PdfsComponent,

  ExhibitorsComponent,

  CountriesComponent



  /*
  LetterComponent,
  LetterShippingComponent,
  LetterDashComponent,
  InviteConfirmComponent,
  InviteUpdateComponent,
  InviteUpdateDataComponent,
  InviteEndComponent,
  */
]
